<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-nav="false">
    <div class="flex a-center h-60">
      <Input class="m-l-15" placeholder="页面名称" style="width: 240px"/>
      <Button class="m-l-15">搜索</Button>
    </div>
    <div class="m-h-15">
      <Table :columns="columns" :data="dataList"
             :height="tableHeight">
        <template v-slot:operation="{row,index}">
          <div class="flex j-between fs-12">
            <span
              @click="delPage(row,index)"
              style="color:red ;cursor: pointer">删除</span>
          </div>
        </template>
      </Table>
      <div style="padding: 10px 0">
        <Page :current.sync="tablePage.currentPage" :page-size="tablePage.pageSize" :page-size-opts="pageSizeOpts"
              :show-total="true"
              :total="tablePage.total" @on-change="onPageChange" @on-page-size-change="onPageSizeChange"
              show-sizer></Page>
      </div>
    </div>
  </base-page-component>
</template>

<script>
import BasePageComponent from '../../components/common/BasePageComponent'
import mixin from '../../config/mixinfile'

export default {
  name: 'AnswerList',
  mixins: [mixin.mixin],
  components: {BasePageComponent},
  data () {
    return {
      tableHeight: 660,
      columns: [
        {
          title: '姓名',
          key: 'key1',
          width: 100
        }, {
          title: '联系电话',
          key: 'key2',
          width: 130
        },
        {
          title: '单位',
          key: 'key3',
          width: 200
        }, {
          title: '微信',
          key: 'key4',
          width: 140
        }, {
          title: '邮箱',
          key: 'key5',
          width: 200
        }, {
          title: '地址',
          key: 'key6',
          width: 350,
          tooltip: true
        }, {
          title: '留言',
          key: 'key7',
          width: 200,
          tooltip: true
        }, {
          title: '自定义',
          key: 'key8',
          minWidth: 200,
          tooltip: true
        }, {
          title: '  ',
          key: 'keys0',
        }, {
          title: '操作',
          slot: 'operation',
          width: 80
        }
      ],
      dataList: [{
        key1: '张三',
        key2: '15221995661',
        key3: '老刀网络科技有限公司',
        key4: 'Wx100000002',
        key5: '15221995661@163.com',
        key6: '山东潍坊胜利东街1800号北海商务大厦4楼1900号',
        key7: '请问这个商品如何购买才符合标准',
        key8: '自定义答案',
      }],
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.setTableHeight()
  },
  methods: {
    init () {
      this.setTableHeight()
    },
    setTableHeight(){
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    /**
     * 分页请求
     * @param e
     */
    onPageChange (e) {
      this.tablePage.currentPage = e
      // this.onGetGoods()
    },
    /**
     * 换页条数请求处理
     * @param e
     */
    onPageSizeChange (e) {
      this.tablePage.pageSize = e
      if (this.tablePage.currentPage === 1) {
        // this.onGetGoods()
      }
    },
    delPage (row) {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
